import { render, staticRenderFns } from "./PolicyService.vue?vue&type=template&id=54df870a&scoped=true&"
import script from "./PolicyService.vue?vue&type=script&lang=js&"
export * from "./PolicyService.vue?vue&type=script&lang=js&"
import style0 from "./PolicyService.vue?vue&type=style&index=0&id=54df870a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54df870a",
  null
  
)

export default component.exports